import React from "react";

const LinearGauge = ({ value, color, partial }) => {
  // Constrain the value between -100 and 100
  const type = value < 0 ? "negative" : "positive";

  return (
    <div className="w-[80%] max-w-[320px] flex flex-col items-center relative mx-auto mt-[39px]">
      {/* Linear gauge bar */}
      {}
      {partial && (
        <>
          <div className="w-full h-[10px] bg-gray-300 rounded-r-full overflow-hidden flex">
            <div className="w-[100%] h-full">
              {type === "positive" && (
                <div
                  className="mr-auto rounded-r-md h-full"
                  style={{
                    width: `${Math.abs((value / 2) * 100)}%`,
                    backgroundColor: color, // Use inline style for the color
                  }}
                ></div>
              )}
            </div>
          </div>
          <div className="absolute w-[1px] h-[57px] bg-black rounded left-0 bottom-6"></div>
        </>
      )}
      {/* //// */}
      {!partial && (
        <>
          {" "}
          <div className="w-full h-[10px] bg-gray-300 rounded-full overflow-hidden flex">
            <div className="w-[50%] h-full">
              {type === "negative" && (
                <div
                  className="ml-auto rounded-l-md h-full"
                  style={{
                    width: `${Math.abs(value)}%`,
                    backgroundColor: color, // Use inline style for the color
                  }}
                ></div>
              )}
            </div>
            <div className="w-[50%] h-full">
              {type === "positive" && (
                <div
                  className="mr-auto rounded-r-md h-full"
                  style={{
                    width: `${Math.abs(value)}%`,
                    backgroundColor: color, // Use inline style for the color
                  }}
                ></div>
              )}
            </div>
          </div>
          <div className="absolute w-[1px] h-[57px] bg-black rounded left-[50%] bottom-6"></div>
        </>
      )}

      {/* Number Labels */}
      {!partial && (
        <div className="flex justify-between mx-auto w-full text-[#737373] mt-8 text-[11px] font-normal">
          <div className="w-[50%] flex justify-end">
            <span className="mr-[15%]">100</span>
            <span className="mr-[18%]">75</span>
            <span className="mr-[15%]">50</span>
            <span className="mr-[20%]">25</span>
          </div>
          <span className="">0</span>
          <div className="w-[50%] flex justify-start">
            <span className="ml-[18%]">25</span>
            <span className="ml-[17%]">50</span>
            <span className="ml-[18%]">75</span>
            <span className="ml-[16%]">100</span>
          </div>
        </div>
      )}
      {partial && (
        <div className="flex justify-between mx-auto w-full text-[#737373] mt-8 text-[11px] font-normal">
          <div className="w-[50%] flex justify-end">
            <span className="mr-[12%]">0</span>
            <span className="mr-[11%]">0.25</span>
            <span className="mr-[14%]">0.5</span>
            <span className="mr-[20%]">0.75</span>
          </div>
          <span className="mr-[1%]">1</span>
          <div className="w-[50%] flex justify-start">
            <span className="ml-[17%]">1.25</span>
            <span className="ml-[15%]">1.5</span>
            <span className="ml-[14%]">1.75</span>
            <span className="ml-[16%]">2</span>
          </div>
        </div>
      )}

      {/* Value Indicator */}
    </div>
  );
};

export default LinearGauge;
